import { useDictionary } from '../../../../../../../utilities/hooks/UseDictionary';
import ParticipantItem from './ParticipantItem';
import React from 'react';
import PropTypes from 'prop-types';
import BookingPaticipants from './BookingPaticipants';

const ParticipantsAndAddons = ({ details }) => {
	const dictionary = useDictionary();
	const bookingParticipantsAndAddons = details.booking_participants && details.booking_participants.length > 0;

	const getParticipantsQuantity = () => {
		let quantity = 0;
		// let result = '';
		details?.participant_groups.map((group) => {
			quantity += group.quantity;
		});
		let diff = parseInt(details?.slot?.capacity) - parseInt(details?.slot?.booked);

		return (
			quantity +
			' ' +
			(quantity > 1 ? dictionary.spots : dictionary.spot) +
			' (' +
			diff.toString() +
			' ' +
			(diff === 1 ? dictionary.spot : dictionary.spots) +
			' ' +
			dictionary.available +
			')'
		);
	};

	return (
		<div className="detail-tab-container thin-scrollbar-trans fade-on-load detail-tab-container-participants">
			<div
				className="participant-row-container"
				style={{ justifyContent: 'space-between', marginBottom: '20px', textAlign: 'end' }}
			>
				<h3
					className="booking-tab-header"
					data-testid="participant-groups-header"
				>
					{dictionary.participants}
				</h3>
				<div
					style={{ fontWeight: 'normal', opacity: '0.6' }}
					className="booking-number"
				>
					{getParticipantsQuantity()}
				</div>
			</div>
			{!bookingParticipantsAndAddons && details?.participant_groups?.map((participant) => (
				<ParticipantItem key={participant.id} participant={participant} />
			))}
			{
				bookingParticipantsAndAddons && details?.booking_participants?.map((participant,index) => (
					<BookingPaticipants key={participant.id} participant={participant} index={index}/>
				))
			}
			{/* <AddButtonSquare isRound={true} label={dictionary.add_new_participant}/>*/}

			{/*<div className='participant-row-container' style={{justifyContent: 'space-between', marginBottom:'20px'}}>
            <h3 className="booking-tab-header" style={{marginTop:'36px'}}>{dictionary.add_ons}</h3>
            <div style={{fontWeight: 'normal', opacity: '0.6'}}
                 className='booking-number'>{details.add_ons.length.toString() + ' ' + dictionary.add_ons}</div>
        </div>
        {details.add_ons.map(addon =>
            <AddonItem addon={addon}/>
        )}*/}
		</div>
	);
};

ParticipantsAndAddons.propTypes = {
	details: PropTypes.object
};

export default ParticipantsAndAddons;
